export enum NotificationPortalEnum {
  Student = 1,
  Instructor = 2,
  Coach = 3,
  Organization = 4,
}
